export default "__VITE_ASSET__BEuRhuso__"